import { useEffect, useRef } from 'react'

/** Roda o callback em intervalo e também ao voltar para a aba. */
export function useIntervaloVisivel(callback, delayMs) {
  const cbRef = useRef(callback)
  cbRef.current = callback

  useEffect(() => {
    if (!delayMs || delayMs < 1000) return undefined

    const tick = () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return
      cbRef.current()
    }

    const id = setInterval(tick, delayMs)
    const onVis = () => {
      if (typeof document === 'undefined' || document.visibilityState === 'visible') {
        cbRef.current()
      }
    }
    document.addEventListener('visibilitychange', onVis)
    window.addEventListener('focus', onVis)
    return () => {
      clearInterval(id)
      document.removeEventListener('visibilitychange', onVis)
      window.removeEventListener('focus', onVis)
    }
  }, [delayMs])
}
